import {Material} from '../../shoppingcart/material';

export class DataDialog {
    verificationUuid?:string;
    message?:string;
    material?:Material;
    email?:string
}
